import { FormikErrors } from 'formik'

import AgentService from '../../../core/services/agent.service'
import {
  biggerThanZero,
  required,
  validAgency,
  validEmail,
  validPhoneLength,
  validPhoneNumber,
} from '../../_utils/formValidators'
import { AgentBrokerDataForm } from './SignUp.view'

const validateEmail = (email: string) => {
  return required.default(email) || validEmail.default(email)
}

const validatePhoneNumber = (phone: string) => {
  return (
    required.default(phone) ||
    validPhoneLength.default(phone) ||
    validPhoneNumber.default(phone)
  )
}

const validateAgency = (agencyId: number) => {
  return required.default(agencyId) || validAgency.default(agencyId)
}

export const validateFieldForm = (formValueFields: AgentBrokerDataForm) => {
  const errors: FormikErrors<AgentBrokerDataForm> = {}

  if (required.default(formValueFields.firstName)) {
    errors.firstName = required.default(formValueFields.firstName)
  }

  if (required.default(formValueFields.lastName)) {
    errors.lastName = required.default(formValueFields.lastName)
  }

  if (validateEmail(formValueFields.email)) {
    errors.email = validateEmail(formValueFields.email)
  }

  if (validatePhoneNumber(formValueFields.phone)) {
    errors.phone = validatePhoneNumber(formValueFields.phone)
  }

  if (required.default(formValueFields.agentBrokerNumber)) {
    errors.agentBrokerNumber = required.default(
      formValueFields.agentBrokerNumber,
    )
  }

  if (AgentService.isAgent()) {
    if (validateAgency(formValueFields.agencyId)) {
      errors.agencyId = validateAgency(formValueFields.agencyId)
    }
  }

  return errors
}
